import { render, staticRenderFns } from "./newBox.vue?vue&type=template&id=78854f55&scoped=true&"
import script from "./newBox.vue?vue&type=script&lang=js&"
export * from "./newBox.vue?vue&type=script&lang=js&"
import style0 from "./newBox.vue?vue&type=style&index=0&id=78854f55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78854f55",
  null
  
)

export default component.exports